import React, { useEffect, useState } from "react";
import styles from "./login.module.css";
import { Alert, Snackbar, TextField, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { setAuthState } from "../../state/auth/authSlice";
import toast from "react-hot-toast";
function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const backgroundStyle = {
    backgroundImage: `url('/assets/login-bg.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { role, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const token = Cookies.get("token");
    if (token !== null && role !== null && user !== null) {
      navigate("/");
    }
  }, []);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setError("");
  };
  function handleSubmit() {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/user/login`,
        {
          username: username,
          password: password,
        },
        { withCredentials: true }
      )
      .then((res) => {
        // console.log(res);
        const storedToken = Cookies.get("token");
        const user = {
          userId: res.data.user.id,
          userName: res.data.user.name,
        };
        const role = {
          roleId: res.data.user.Role.id,
          roleName: res.data.user.Role.name,
        };
        dispatch(
          setAuthState({
            storedToken,
            user,
            role,
          })
        );
        if (!res.data?.user?.isActivated) {
          toast.error("حسابك مقفل، الرجاء التواصل مع المدير.");
        }
        setLoading(false);
        if (role?.roleName === "SuperAdmin") {
          navigate("/app");
        } else {
          navigate("/app/views");
        }
        toast.success("تم تسجيل الدخول بنجاح");
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response?.data?.message || err.message);
        setOpenSnackbar(true);
      });
  }
  return (
    <div className={styles.Login}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={"error"}
          sx={{ width: "100%" }}
        >
          {error}
        </Alert>
      </Snackbar>
      <div className={styles.LeftSide} style={backgroundStyle}>
        {/* <div className={styles.laser}>
          <span>Powered By:</span>
          <img src="/assets/laser.png" alt="laser-logo" />
        </div> */}
      </div>
      <div className={styles.RightSide}>
        <form className={styles.loginForm}>
          <div className={styles.container}>
            <div className={styles.logo}>
              <img src="/assets/lavr-logo.png" alt="lavr-logo" />
            </div>
            <div className={styles.heading}>
              <Typography
                fontWeight={700}
                variant="h3"
                sx={{ color: theme.palette.neutral[900], marginBottom: "12px" }}
              >
                تسجيل الدخول
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: theme.palette.neutral[600], marginBottom: "20px" }}
              >
                من فضلك أدخل المعلومات أسفل
              </Typography>
            </div>
            <div className={styles.textfields} dir="rtl">
              <TextField
                label="اسم المستخدم"
                value={username}
                autoComplete="off"
                className={styles.inputs}
                name="username"
                type="text"
                fullWidth={true}
                onChange={(e) => setUsername(e.target.value)}
                slotProps={{
                  input: {
                    style: { direction: "rtl" },
                  },
                  inputLabel: {
                    style: { textAlign: "right", direction: "rtl" },
                  },
                }}
              />
              <TextField
                label="كلمة السر"
                value={password}
                autoComplete="off"
                className={styles.inputs}
                name="password"
                type="password"
                fullWidth={true}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => (e.key === "Enter" ? handleSubmit() : "")}
              />
            </div>
            <LoadingButton
              variant="contained"
              loading={loading}
              loadingIndicator="جاري التحميل..."
              onClick={handleSubmit}
              fullWidth={true}
            >
              تسجيل الدخول
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
